"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DIRECTIONS = exports.CREATE_OPTION_ROLE = exports.SEARCH_INPUT_ROLE = exports.ARROW_UP_KEY = exports.ARROW_DOWN_KEY = exports.ENTER_KEY = exports.TAB_KEY = exports.TAB_INDEX_ATTRIBUTE = exports.ROLE_ATTRIBUTE = exports.TABBING_ATTRIBUTE = exports.TABBING_KEY = void 0;
exports.TABBING_KEY = 'tabbable';
exports.TABBING_ATTRIBUTE = 'aria-details';
exports.ROLE_ATTRIBUTE = 'role';
exports.TAB_INDEX_ATTRIBUTE = 'tabindex';
exports.TAB_KEY = 'Tab';
exports.ENTER_KEY = 'Enter';
exports.ARROW_DOWN_KEY = 'ArrowDown';
exports.ARROW_UP_KEY = 'ArrowUp';
exports.SEARCH_INPUT_ROLE = 'searchbox';
exports.CREATE_OPTION_ROLE = 'textbox';
var DIRECTIONS;
(function (DIRECTIONS) {
    DIRECTIONS["NEXT"] = "next";
    DIRECTIONS["PREVIOUS"] = "previous";
})(DIRECTIONS || (exports.DIRECTIONS = DIRECTIONS = {}));
